
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.825 6.258C8.496 5.474 7 6.541 7 7.963v5.574c0 1.422 1.496 2.489 2.825 1.705l4.72-2.787c1.273-.752 1.273-2.658 0-3.41l-4.72-2.787zM8.5 7.963c0-.198.096-.337.21-.408a.323.323 0 01.352-.005l4.72 2.787a.465.465 0 01.218.413.465.465 0 01-.218.413l-4.72 2.787a.323.323 0 01-.353-.005.467.467 0 01-.209-.408V7.963z","fill":"#624DE3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.75 0C4.813 0 0 4.813 0 10.75S4.813 21.5 10.75 21.5 21.5 16.687 21.5 10.75 16.687 0 10.75 0zM1.5 10.75a9.25 9.25 0 1118.5 0 9.25 9.25 0 01-18.5 0z","fill":"#624DE3"}})])
          )
        }
      }
    